"use client";

import { c as _c } from "react/compiler-runtime";
import { useDesktopAnimations } from "@/lib/breakpoints";
import React, { useState } from "react";
import Image from "next/image";
import GradientButton from "@/components/ui/GradientButton";
import { motion, AnimatePresence } from "framer-motion";
import { FaChevronRight } from "react-icons/fa";
export interface IndustryDetail {
  id: string;
  label: string;
  icon: string;
  title: string;
  description: string;
  points: string[];
}
export const laravelIndustriesData: IndustryDetail[] = [{
  id: "real-estate",
  label: "Real estate",
  icon: "/images/flutter/real-estate.png",
  title: "Real Estate Solutions",
  description: "Empowering real estate businesses with custom property portals, MLS integration, and robust CRM systems tailored for agents and buyers.",
  points: ["Property Listing & Search Portals", "Real Estate CRM & Lead Management", "Virtual Tour & Map Integrations", "Property Management & Lease Systems"]
}, {
  id: "tour-travels",
  label: "Tour & Travels",
  icon: "/images/flutter/tour-travels.png",
  title: "Tour & Travel Solutions",
  description: "Delivering high-performance travel booking engines, itinerary management tools, and seamless API integrations for global travel agencies.",
  points: ["Online Travel Booking Engines", "Custom Itinerary Planners", "Flight & Hotel API Integrations", "Real-Time Reservation Management"]
}, {
  id: "education",
  label: "Education",
  icon: "/images/flutter/education.png",
  title: "Education Solutions",
  description: "Empowering the education sector with smart digital tools. Our solutions ensure seamless learning experiences for students and efficient management for institutions.",
  points: ["E-Learning Platforms & LMS", "Mobile Education Applications", "Virtual Classrooms & Live Streaming", "School & University Management Systems"]
}, {
  id: "transport",
  label: "Transport",
  icon: "/images/flutter/transport.png",
  title: "Transport & Logistics",
  description: "Building robust logistics and transport management systems for automated dispatch, real-time routing, and fleet performance monitoring.",
  points: ["Fleet Management & Tracking", "Logistics & Supply Chain Portals", "Automated Dispatch & Route Optimization", "Driver & Passenger Mobile Portals"]
}, {
  id: "event",
  label: "Event",
  icon: "/images/flutter/event.png",
  title: "Event Management Solutions",
  description: "Creating scalable event booking, ticketing, and live engagement platforms for virtual, hybrid, and in-person conferences.",
  points: ["Online Ticket Booking & QR Check-ins", "Virtual Event & Webinar Platforms", "Speaker & Schedule Management", "Attendee Networking & Analytics"]
}, {
  id: "ecommerce",
  label: "eCommerce",
  icon: "/images/flutter/ecommerce.png",
  title: "eCommerce Solutions",
  description: "Building high-conversion online stores, multi-vendor marketplaces, and custom checkout flows powered by Laravel.",
  points: ["Custom B2B & B2C eCommerce Stores", "Multi-Vendor Marketplace Platforms", "Secure Payment Gateway Integrations", "Inventory & Order Management Systems"]
}, {
  id: "manufacturer",
  label: "Manufacturer",
  icon: "/images/flutter/manufacturer.png",
  title: "Manufacturing Solutions",
  description: "Streamlining manufacturing operations with custom ERP systems, warehouse tracking, and vendor management software.",
  points: ["Custom Manufacturing ERP Systems", "Warehouse & Inventory Tracking", "Production Scheduling & Monitoring", "Supplier & Vendor Collaboration Portals"]
}, {
  id: "healthcare",
  label: "Healthcare",
  icon: "/images/flutter/healthcare.png",
  title: "Healthcare Solutions",
  description: "Developing secure, HIPAA-compliant healthcare applications, patient portals, and telemedicine solutions for clinics and hospitals.",
  points: ["Telemedicine & Video Consultation", "Patient Record Management (EHR/EMR)", "Hospital & Clinic Workflow Systems", "Online Doctor Appointment Scheduling"]
}, {
  id: "finance",
  label: "Finance",
  icon: "/images/flutter/finance.png",
  title: "Finance & Banking Solutions",
  description: "Designing secure financial web apps, fintech tools, automated billing engines, and accounting management platforms.",
  points: ["Fintech Web & Mobile Solutions", "Secure Payment Gateways & Wallets", "Automated Invoicing & Billing", "Investment & Wealth Management Portals"]
}, {
  id: "restaurant",
  label: "Restaurant",
  icon: "/images/flutter/restaurant.png",
  title: "Restaurant & Food Solutions",
  description: "Empowering restaurants and food chains with online ordering systems, table reservations, and integrated POS management.",
  points: ["Online Food Ordering & Delivery", "Table Reservation & Waitlist Systems", "Cloud Kitchen & Multi-Branch POS", "Digital Menu & Kitchen Display Systems"]
}, {
  id: "on-demand",
  label: "On-Demand",
  icon: "/images/flutter/on-demand.png",
  title: "On-Demand Solutions",
  description: "Connecting customers with instant service providers through robust matching algorithms, live GPS tracking, and automated billing.",
  points: ["On-Demand Service Booking Apps", "Real-Time Geo-Location & Tracking", "In-App Chat & Multi-Currency Payment", "Service Provider & Admin Dashboards"]
}, {
  id: "grocery",
  label: "Grocery",
  icon: "/images/flutter/grocery.png",
  title: "Grocery Delivery Solutions",
  description: "Powering online supermarket delivery with smart inventory tracking, scheduled delivery windows, and seamless customer apps.",
  points: ["Single & Multi-Store Grocery Apps", "Smart Search & Barcode Scanning", "Delivery Slot Scheduling & Optimization", "Inventory Management & Stock Alerts"]
}];
export default function LaravelIndustries() {
  const $ = _c(30);
  const desktopAnimations = useDesktopAnimations();
  const [activeIndex, setActiveIndex] = useState(0);
  const activeIndustry = laravelIndustriesData[activeIndex] || laravelIndustriesData[0];
  let t0;
  if ($[0] !== activeIndex) {
    t0 = laravelIndustriesData.map((item, idx) => {
      const isActive = activeIndex === idx;
      return <button key={item.id} type="button" role="tab" aria-selected={isActive} onClick={() => setActiveIndex(idx)} className={`group cursor-pointer relative flex shrink-0 sm:shrink w-[110px] min-w-[110px] sm:w-auto sm:min-w-0 h-[108px] sm:h-auto flex-col items-center  justify-center rounded-[10px] p-3 text-center transition-all duration-300 focus:outline-none ${isActive ? "bg-[#2d86e8]  -translate-y-0.5" : "bg-white  hover:-translate-y-0.5  dark:bg-gray-900"}`}><div className="mb-2 flex h-10 w-10 sm:h-11 sm:w-11 items-center justify-center"><Image src={item.icon} alt={item.label} width={44} height={44} loading="lazy" className="h-full w-full object-contain transition-transform duration-300 group-hover:scale-105" /></div><span className={`font-poppins text-[11.5px] sm:text-[13px] font-medium leading-tight ${isActive ? "text-white" : "text-[#050748] dark:text-gray-200"}`}>{item.label}</span></button>;
    });
    $[0] = activeIndex;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  let t1;
  if ($[2] !== t0) {
    t1 = <div className="lg:col-span-6"><div role="tablist" className="flex flex-row items-center overflow-x-auto gap-3 pb-3 sm:pb-0 sm:grid sm:grid-cols-4 sm:gap-4 no-scrollbar -mx-4 px-4 sm:mx-0 sm:px-0">{t0}</div></div>;
    $[2] = t0;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  let t2;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <span className="font-poppins mb-2 text-xs font-bold uppercase tracking-wider text-[#E60072] sm:text-sm">INDUSTRIES WE WORK FOR</span>;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  const t3 = activeIndustry.id;
  let t4;
  if ($[5] !== desktopAnimations) {
    t4 = desktopAnimations ? {
      opacity: 0,
      y: 15
    } : false;
    $[5] = desktopAnimations;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  let t5;
  let t6;
  let t7;
  if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = {
      opacity: 1,
      y: 0
    };
    t6 = {
      opacity: 0,
      y: -15
    };
    t7 = {
      duration: 0.35,
      ease: "easeOut"
    };
    $[7] = t5;
    $[8] = t6;
    $[9] = t7;
  } else {
    t5 = $[7];
    t6 = $[8];
    t7 = $[9];
  }
  let t8;
  if ($[10] !== activeIndustry.title) {
    t8 = <h2 className="font-poppins mb-4 text-[28px] font-bold leading-[1.25] text-[#050748] sm:text-[34px] lg:text-[40px] dark:text-white">{activeIndustry.title}</h2>;
    $[10] = activeIndustry.title;
    $[11] = t8;
  } else {
    t8 = $[11];
  }
  let t9;
  if ($[12] !== activeIndustry.description) {
    t9 = <p className="font-sans mb-6 text-[15px] font-normal leading-[1.75] text-[#5e6282] sm:text-[16px] dark:text-gray-300">{activeIndustry.description}</p>;
    $[12] = activeIndustry.description;
    $[13] = t9;
  } else {
    t9 = $[13];
  }
  let t10;
  if ($[14] !== activeIndustry.points) {
    t10 = activeIndustry.points.map(_temp);
    $[14] = activeIndustry.points;
    $[15] = t10;
  } else {
    t10 = $[15];
  }
  let t11;
  if ($[16] !== t10) {
    t11 = <ul className="mb-8 space-y-3.5">{t10}</ul>;
    $[16] = t10;
    $[17] = t11;
  } else {
    t11 = $[17];
  }
  let t12;
  if ($[18] !== activeIndustry.id || $[19] !== t11 || $[20] !== t4 || $[21] !== t8 || $[22] !== t9) {
    t12 = <AnimatePresence mode="wait"><motion.div key={t3} initial={t4} animate={t5} exit={t6} transition={t7} className="w-full">{t8}{t9}{t11}</motion.div></AnimatePresence>;
    $[18] = activeIndustry.id;
    $[19] = t11;
    $[20] = t4;
    $[21] = t8;
    $[22] = t9;
    $[23] = t12;
  } else {
    t12 = $[23];
  }
  let t13;
  if ($[24] === Symbol.for("react.memo_cache_sentinel")) {
    t13 = <GradientButton href="/contact" variant="store-blue" className="!h-[52px] min-w-[165px] !font-medium  !transition-all ease-out hover:-translate-y-[2px] "><span>View More</span><FaChevronRight className="text-[12px] transition-transform duration-300 group-hover:translate-x-0.5" /></GradientButton>;
    $[24] = t13;
  } else {
    t13 = $[24];
  }
  let t14;
  if ($[25] !== t12) {
    t14 = <div className="flex flex-col items-start lg:col-span-6">{t2}{t12}{t13}</div>;
    $[25] = t12;
    $[26] = t14;
  } else {
    t14 = $[26];
  }
  let t15;
  if ($[27] !== t1 || $[28] !== t14) {
    t15 = <section className="relative w-full overflow-hidden bg-[linear-gradient(to_bottom,#fbf9ed_0%,#fbeaf8_100%)] py-16 font-sans transition-colors duration-300 sm:py-20 lg:py-24 dark:bg-[#0b0f19] dark:bg-none"><div className="mx-auto w-full max-w-[1280px] px-4 sm:px-6 lg:px-8"><div className="grid grid-cols-1 items-center gap-12 lg:grid-cols-12 lg:gap-14">{t1}{t14}</div></div></section>;
    $[27] = t1;
    $[28] = t14;
    $[29] = t15;
  } else {
    t15 = $[29];
  }
  return t15;
}
function _temp(point, i) {
  return <li key={i} className="flex items-center gap-3 font-sans text-[14.5px] font-medium text-[#050748] sm:text-[15.5px] dark:text-gray-200"><span className="flex h-4 w-4 shrink-0 items-center justify-center rounded-full border-2 border-[#2d86e8]"><span className="h-1.5 w-1.5 rounded-full bg-[#2d86e8]" /></span><span>{point}</span></li>;
}